import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { lazy } from "react";
import { BiClinic } from "react-icons/bi";
import { MdPayments } from "react-icons/md";
import ForumRoundedIcon from '@mui/icons-material/ForumRounded';
import SchoolIcon from '@mui/icons-material/School';
import { BsCardChecklist } from "react-icons/bs";
import { LiaUserNurseSolid } from "react-icons/lia";
import { Navigate, Route, Routes } from "react-router-dom";
import { HOME_PATH, LOGIN_PATH } from "../appConstants.js";
import LayoutWrapper from "../layouts/LayoutWrapper.js";
import ProtectedRoute from "../middlewares/ProtectedRoute.js";
import RootRoute from "../middlewares/RootRoute.js";
// import { LuCircleHelp, LuUser} from "react-icons/lu";
import { LuHelpCircle, LuUser } from "react-icons/lu";
import { LuWallet } from "react-icons/lu";
import { ImportUsers } from "../pages/AdminPages/Profile/importUser.js";
import AddLocation from "../pages/FacilityPages/Profile/addLoaction.js";
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import { MultiStepJobPost } from "../pages/FacilityPages/Jobs/multiStepJobPost.js";
import { GenericMultiStep } from '../pages/AdminPages/AdminComponents/genericMultiStep.js';
import ClinicianJobs from "../pages/ClinicianPages/Jobs/clinicianJobs.js";
import FacilityJobs from "../pages/FacilityPages/Jobs/facilityJobs.js";
import AddRole from "../pages/AdminPages/Roles/AddRole.js";
import Roles from "../pages/AdminPages/Roles/Roles.js";
import ViewClinicianProfile from "../pages/ClinicianPages/Jobs/viewClinicianProfile.js";
import ViewJobAndClinician from "../pages/FacilityPages/Jobs/viewJobAndClinician.js";
import ViewJobInFacility from "../pages/FacilityPages/Jobs/viewJobInFacility.js";
import MyJobs from '../pages/ClinicianPages/Jobs/MyJobs.js';
import JobofferAccepted from "../components/Job/jobofferAccepted.js";
import JobOfferEmailView from "../components/Job/JobOfferEmailView.js";
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import ViewJob from "../components/Job/viewJob.js";
import PostedJobs from '../pages/FacilityPages/Jobs/AppliedJobs.js';
import RequestedJobs from '../pages/AdminPages/Jobs/RequestedJobs.js';
import ViewJobApplicantsDetails from '../pages/AdminPages/Jobs/ViewJobApplicantsDetails.js';
import ShiftRates from '../pages/CommonViewPages/ShiftRates.js';
import ApplicantsInTimeSheet from '../pages/CommonViewPages/ApplicantsInTimeSheet.js';
import ClinicianTimesheetForPayment from '../pages/CommonViewPages/ClinicianTimesheetForPayment.js';
import ViewClinicianTimeSheet from '../pages/FacilityPages/Jobs/viewcClinicianTimesheet.js';
import PaymentConfirmationScreen from '../pages/CommonViewPages/PaymentConfirmationScreen.js';
import AdminTransactionReport from '../pages/AdminPages/Reports/AdminTransactionReport.js';
import AdminAccounting from '../pages/AdminPages/Profile/AdminAccounting/AdminAccounting.js';
import { VscAccount } from "react-icons/vsc";
import AddSpecialtyFacility from '../pages/FacilityPages/Profile/AddSpecialtyFacility.js';
import MobileClinicianEditOnboardingDocument from '../pages/ClinicianPages/Profile/MobileClinicianEditOnboardingDocument.js';
/*****Profile Criteria Routes******/

//Specialties
const ClinicianCheck = lazy(() => import("../pages/ClinicianPages/Profile/ClinicianCheck.js"));
const Specialties = lazy(() => import("../pages/AdminPages/Profile/ProfileCriteria/Specialties/Specialties.js"));
const AddSpecialty = lazy(() => import("../pages/AdminPages/Profile/ProfileCriteria/Specialties/AddSpecialty.js"));
const AssignSpecialty = lazy(() => import("../pages/AdminPages/Profile/ProfileCriteria/Specialties/MapSpecialtyToJobRole.js"));
//Job Roles
const AddJobRole = lazy(() => import("../pages/AdminPages/Profile/ProfileCriteria/JobRoles/AddJobRole.js"));
const JobRoleCredentials = lazy(() => import("../pages/AdminPages/Profile/ProfileCriteria/JobRoles/JobRoleCredentials.js"));
const AssignJobRole = lazy(() => import("../pages/AdminPages/Profile/ProfileCriteria/JobRoles/MapJobRoleToSpecialties.js"));
// OnBoarding Documents
const AddOnBoardingDocuments = lazy(() => import("../pages/AdminPages/Profile/ProfileCriteria/OnBoardingDocuments/OnBoardingDocuments.js"));
/****Admin Routes*****/
const AdminUsers = lazy(() => import("../pages/AdminPages/Profile/AdminUsers.js"));
const AdminClinicians = lazy(() => import("../pages/AdminPages/Profile/AdminClinicians.js"));
const AdminRequestedList = lazy(() => import("../pages/AdminPages/Profile/AdminRequestedList.js"))
const FacilityClinicians = lazy(() => import("../pages/FacilityPages/Profile/FacilityClinicians.js"));
const AdminFacilities = lazy(() => import("../pages/AdminPages/Profile/AdminFacilities.js"));
const AddUser = lazy(() => import("../pages/AdminPages/Profile/AddUser.js"));
const UserAccess = lazy(() => import("../pages/AdminPages/Profile/UserAccess.js"));
const AdminProfileCriteria = lazy(() => import("../pages/AdminPages/Profile/ProfileCriteria/AdminProfileCriteria.js"));
const AdminSchedule = lazy(() => import("../pages/AdminPages/Profile/ProfileCriteria/AdminSchedule.js"));
const AdminJobs = lazy(() => import("../pages/AdminPages/Profile/ProfileCriteria/AdminJobs.js"));
const WorkArea = lazy(() => import("../pages/AdminPages/Profile/ProfileCriteria/WorkArea/WorkArea.js"));
const AddWorkArea = lazy(() => import("../pages/AdminPages/Profile/ProfileCriteria/WorkArea/AddWorkArea.js"));
const WorkType = lazy(() => import("../pages/AdminPages/Profile/ProfileCriteria/WorkType/WorkType.js"));
const AddWorkType = lazy(() => import("../pages/AdminPages/Profile/ProfileCriteria/WorkType/AddWorkType.js"));
const ManageEditClinicianAbout = lazy(() => import("../pages/CommonViewPages/ManageEditClinicianAbout.js"));
const ManageEditFacilityAbout = lazy(() => import("../pages/CommonViewPages/ManageEditFacilityAbout.js"));
const ConfirmConnection = lazy(() => import("../pages/CommonViewPages/ConfirmConnection.js"));
const HealthDocuments = lazy(() => import("../pages/AdminPages/Profile/ProfileCriteria/HealthDocuments/HealthDocuments.js"))
const LearningDocuments = lazy(() => import("../pages/AdminPages/Profile/ProfileCriteria/Learnings/Learning.js"))
const Certifications = lazy(() => import("../pages/AdminPages/Profile/ProfileCriteria/Certifications/Certifications.js"))
const FAQs = lazy(() => import("../pages/AdminPages/Profile/ProfileCriteria/FAQs/FAQ.js"))
const AddFAQs = lazy(() => import("../pages/AdminPages/Profile/ProfileCriteria/FAQs/AddFAQ.js"));
const AllTimeSheet = lazy(() => import("../pages/CommonViewPages/AllTimeSheet.js"));

/*****FacilityPages Routes******/
const FacilitySignupForm = lazy(() => import("../pages/Authentications/FacilitySignup/FacilitySignupForm.js"));
const FacilityDashboard = lazy(() => import("../pages/FacilityPages/Profile/FacilityProfile.js"));
const FacilityEditProfile = lazy(() => import("../pages/FacilityPages/Profile/EditProfile.js"));
const FacilityDashboardData = lazy(() => import("../pages/FacilityPages/Schedule/FacilityData.js"));

// Facitlity Shift Schedule

const FacilityRequesedShiftScheduleList = lazy(() => import("../pages/FacilityPages/Schedule/FacilityRequestedShiftScheduleList.js"));
const FacilityApprovedShiftScheduleList = lazy(() => import("../pages/FacilityPages/Schedule/FacilityApprovedShiftScheduleList.js"));
const FacilityTimeApprovalShiftScheduleList = lazy(() => import("../pages/FacilityPages/Schedule/FacilityTimeApprovalShiftScheduleList.js"));
const FacilityOpenShiftScheduleList = lazy(() => import("../pages/FacilityPages/Schedule/FacilityOpenShiftScheduleList.js"));
const FacilityPendingShiftRequestedList = lazy(() => import("../pages/FacilityPages/Schedule/FacilityPendingShiftRequestedList.js"));
const FacilityCanceledShiftScheduleList = lazy(() => import("../pages/FacilityPages/Schedule/FacilityCanceledShiftScheduleList.js"));

// New shift category components
const FacilityTodayShiftsList = lazy(() => import("../pages/FacilityPages/Schedule/FacilityTodayShiftsList.js"));
const FacilityUpcomingShiftsList = lazy(() => import("../pages/FacilityPages/Schedule/FacilityUpcomingShiftsList.js"));
const FacilityPastShiftsList = lazy(() => import("../pages/FacilityPages/Schedule/FacilityPastShiftsList.js"));
const FacilityCompletedShiftsList = lazy(() => import("../pages/FacilityPages/Schedule/FacilityCompletedShiftsList.js"));



const FacilityRequestShift = lazy(() => import("../pages/FacilityPages/Schedule/FacilityRequestShift.js"));
const FacilityScheduleShift = lazy(() => import("../pages/FacilityPages/Schedule/FacilityScheduleShift.js"));
const FacilityTimeEntries = lazy(() => import("../pages/FacilityPages/Schedule/FacilityTimeEnteries.js"));
const FacilityTimeEntry = lazy(() => import("../pages/FacilityPages/Schedule/FacilityTimeEntry.js"));
const FacilityDocument = lazy(() => import("../pages/FacilityPages/Schedule/FacilityDocument.js"));
const FacilityApprove = lazy(() => import("../pages/FacilityPages/Schedule/FacilityApprove.js"));
const FacilityTimeApproval = lazy(() => import("../pages/FacilityPages/Schedule/FacilityTimeApproval.js"));
const FacilityOpenShifts = lazy(() => import("../pages/FacilityPages/Schedule/FacillityOpenShift.js"));
const FacilityCancelShifts = lazy(() => import("../pages/FacilityPages/Schedule/FacilityCancelShift.js"));

const FacilityInviteFriend = lazy(() => import("../pages/FacilityPages/FacilityInviteFriend/InviteFriend.js"));
// const FacilityShiftScheduleList = lazy(() => import("../pages/FacilityPages/Schedule/FacilityShiftScheduleList.js"));
// const FacilityInviteFriend = lazy(() => import("../pages/FacilityPages/FacilityInviteFriend/InviteFriend.js"));
// const FacilityHelpData = lazy(() => import("../pages/FacilityPages/FacilityHelp/FacilityHelpMainComponent.js"));

/*****ClinicianPages Routes******/
const ClinicianProfile = lazy(() => import("../pages/ClinicianPages/Profile/ClinicianProfile.js"));
const ClinicianSignupForm = lazy(() => import("../pages/Authentications/Signup/ClinicianSignupForm.js"));
const ClinicianOnBoardSetup = lazy(() => import("../pages/Authentications/OnBoardSetup/ClinicianOnBoardSetup.js"));
const ClinicianAboutEditProfile = lazy(() => import("../pages/ClinicianPages/Profile/ClinicianEditProfile.js"));
const ClinicianAddressEditProfile = lazy(() => import("../pages/ClinicianPages/Profile/ClinicianEditAddress.js"));
const ClinicianChangePassword = lazy(() => import("../pages/ClinicianPages/Profile/ClinicianEditPassword.js"));
const AddClinicianSpecialty = lazy(() => import("../pages/ClinicianPages/Profile/AddClinicianSpecialty.js"));
const AddClinicianLicense = lazy(() => import("../pages/ClinicianPages/Profile/AddClinicianLicense.js"));
const AddClinicianResume = lazy(() => import("../pages/ClinicianPages/Profile/AddClinicianResume.js"));
const AddClinicianExperience = lazy(() => import("../pages/ClinicianPages/ClinicianComponents/AddClinicianExperience.js"));
const AddClinicianRefernce = lazy(() => import("../pages/ClinicianPages/ClinicianComponents/AddClinicianRefernce.js"));

// Academy routes
const ClinicianTrainings = lazy(() => import("../pages/ClinicianPages/Academy/ClinicianTrainings.js"));
const ClinicianLessonDetails = lazy(() => import("../pages/ClinicianPages/Academy/ClinicianLessonDetails.js"));
const InProgress = lazy(() => import("../pages/ClinicianPages/Academy/Inprogress.js"));
const CompletedCertificate = lazy(() => import("../pages/ClinicianPages/Academy/Completed.js"));
const Lessons = lazy(() => import("../pages/ClinicianPages/Academy/Lessons.js"));
const ViewCertificate = lazy(() => import("../pages/ClinicianPages/Academy/ViewCertificate.js"))


const ClinicianBLSCertificate = lazy(() => import("../pages/ClinicianPages/Profile/EditblsCertificate.js"));
const ClinicianAddNewCertificate = lazy(() => import("../pages/ClinicianPages/Profile/Editnewcertificate.js"));
const ClinicianUploadCertificate = lazy(() => import("../pages/ClinicianPages/Profile/EditUploadCertificate.js"));
const ClinicianHealthDocument = lazy(() => import("../pages/ClinicianPages/Profile/Edithealthdocuments.js"));
const ClinicianUploadDocument = lazy(() => import("../pages/ClinicianPages/Profile/EditUploadDocuments.js"));
const ClinicianIssueDate = lazy(() => import("../pages/ClinicianPages/Profile/EditIssuedate.js"));
const ClinicianExpirationDate = lazy(() => import("../pages/ClinicianPages/Profile/EditExpirationDate.js"));
const ClinicianNotes = lazy(() => import("../pages/ClinicianPages/Profile/EditNotes.js"));
const AddClinicianCertificate = lazy(() => import("../pages/ClinicianPages/Profile/Addnewcertificate.js"));


const ClinicianCertificationDocument = lazy(() => import("../pages/ClinicianPages/Profile/Editcertificationdocuments.js"));
const ClinicianCertificationUploadDocument = lazy(() => import("../pages/ClinicianPages/Profile/EditCertificationUploadDocuments.js"));
const ClinicianCertificationIssueDate = lazy(() => import("../pages/ClinicianPages/Profile/EditcCertificationIssueDate.js"));
const ClinicianCertificationExpirationDate = lazy(() => import("../pages/ClinicianPages/Profile/EditcCertificationExpirationDate.js"));
const ClinicianCertificationNotes = lazy(() => import("../pages/ClinicianPages/Profile/EditCertificationNotes.js"));

const ClinicianDashboardData = lazy(() => import("../pages/ClinicianPages/Schedule/ClinicianData.js"));

const ClinicianShiftScheduleList = lazy(() => import("../pages/ClinicianPages/Schedule/ClinicianShiftScheduleList.js"));


const ClinicianOpenShiftScheduleList = lazy(() => import("../pages/ClinicianPages/Schedule/ClinicianOpenShiftScheduleList.js"))
const Calendars = lazy(() => import("../components/Calendar/Calendar.js")) // just for testing do not merge
const ClinicianRequestShift = lazy(() => import("../pages/ClinicianPages/Schedule/ClinicianRequestShift.js"));
const ClinicianOpenShift = lazy(() => import("../pages/ClinicianPages/Schedule/ClinicianOpenShift.js"));
const ClinicianAllShift = lazy(() => import("../pages/ClinicianPages/Schedule/ClinicianAllShift.js"));
const ClinicianTimeEntries = lazy(() => import("../pages/ClinicianPages/Schedule/ClinicianTimeEnteries.js"));
const ClinicianTimeEntry = lazy(() => import("../pages/ClinicianPages/Schedule/ClinicianTimeEntry.js"));
const ClinicianTimeShift = lazy(() => import("../pages/ClinicianPages/Schedule/ClinicianTimeShift.js"));


const ClinicianProfileOnboardingDocument = lazy(() => import("../pages/ClinicianPages/Profile/ClinicianProfileOnboardingDocument.js"));
const ClinicianAppliedJobDetails = lazy(() => import("../pages/CommonViewPages/clinicianAppliedJobDetails.js"));

const ClinicianBackgroundCheck = lazy(() => import("../pages/ClinicianPages/Profile/EditBackgroundCheck.js"));
const ClinicianBankDetails = lazy(() => import("../pages/ClinicianPages/Profile/ClinicianBankDetailsForm.js"));

// const Address = lazy(() => import("../pages/ClinicianPages/Profile/Address.js"));
// const ResumeUpload = lazy(() => import("../pages/ClinicianPages/Profile/ResumeUpload.js"));
// const ClinicianChecklist = lazy(() => import("../pages/ClinicianPages/Profile/ClinicianChecklist.js"));

const AssessSpecialities = lazy(() => import("../pages/ClinicianPages/Profile/AssessSpecialities.js"));
const AssessSpecialitiesById = lazy(() => import("../pages/FacilityPages/Credentials/AccessSpecialitiesFaculty.js"));
const AssessYourSpecialities = lazy(() => import("../pages/ClinicianPages/Profile/AssessYourSpeciality.js"));
const Assessment = lazy(() => import("../pages/ClinicianPages/Profile/Assessment.js"));
const ClinicianWalletData = lazy(() => import("../pages/ClinicianPages/ClinicianWallet/WalletMainComponent.js"))
const InviteFriendData = lazy(() => import("../pages/ClinicianPages/InviteFriend/InviteFriend.js"))
const ClinicianHelpData = lazy(() => import("../pages/ClinicianPages/ClinicianHelp/HelpMainComponent.js"))

//common Routes
const FullLayout = lazy(() => import("../layouts/FullLayout/FullLayout.js"));
const MultiStepForgetPassword = lazy(() => import("../pages/Authentications/ForgetPassword/MultiStepForgetPassword.js"));
const ChooseSignupType = lazy(() => import("../pages/Authentications/Signup/ChooseSignupType.js"));
const Login = lazy(() => import("../pages/Authentications/Login.js"));
const Home = lazy(() => import("../pages/Home/Home.js"));
const Unauthorized = lazy(() => import("../components/NotFoundPage/NotFoundPage.js"));
// const NotFoundPage = lazy(() => import("../pages/Authentications/NotFoundPage.js"));
const NotFoundPage = lazy(() => import("../pages/Authentications/NotFoundPage.js"));
const ClinicianUserProfile = lazy(() => import("../pages/CommonViewPages/ClinicianUserProfile.js"));
const FacilityUserProfile = lazy(() => import("../pages/CommonViewPages/FacilityUserProfile.js"));
const Calendar = lazy(() => import("../components/Calendar/Calendar.js")) // just for testing do not merge
const ShiftCalendar = lazy(() => import("../components/Calendar/ShiftCalendar.js"))
const MobilePdfViewer = lazy(() => import("../pages/ClinicianPages/Profile/MobilePdfViewer.jsx"))
// ritik made below changes
const Messages = lazy(() => import("../components/Messages/Inbox.js"));
const ClinicianMessages = lazy(() => import("../pages/ClinicianPages/Message/messageWindow.js"));
// const AdminMessages = lazy(() => import("../pages/ClinicianPages/Message/adminMessageWindow.js"));



const AdminDashboard = lazy(() => import("../pages/AdminPages/Dashboard/AdminDashboard.js"))
const TransactionList = lazy(() => import("../pages/FacilityPages/Payment/Transactionlist.js"))
const FacilityTransactionReport = lazy(() => import("../pages/FacilityPages/Profile/FacilityTransactionReport.js"))



let allRoutes = [

  { path: '/clinician/profile', screenRight: "Clinician Profile", title: "Profile", icon: LuUser, showSideBar: true, element: ClinicianProfile },
  { path: '/clinician/profile/edit', screenRight: "Clinician Profile", showSideBar: false, element: ClinicianAboutEditProfile },
  { path: '/clinician/profile/changeAddress', screenRight: "Clinician Profile", showSideBar: false, element: ClinicianAddressEditProfile },
  { path: '/clinician/profile/changePassword', screenRight: "Clinician Profile", showSideBar: false, element: ClinicianChangePassword },
  { path: '/clinician/profile/add-specialties', screenRight: "Clinician Profile", showSideBar: false, element: AddClinicianSpecialty },
  { path: '/clinician/profile/add-CheckList/:specialityID', screenRight: "Clinician Profile", showSideBar: false, element: ClinicianCheck },
  { path: '/clinician/profile/add-license/:licenseID', screenRight: "Clinician Profile", showSideBar: false, element: AddClinicianLicense },
  { path: '/clinician/profile/add-license', screenRight: "Clinician Profile", showSideBar: false, element: AddClinicianLicense },
  { path: '/clinician/profile/add-resume', screenRight: "Clinician Profile", showSideBar: false, element: AddClinicianResume },
  { path: '/clinician/profile/uploadresume', screenRight: "Clinician Profile", showSideBar: false, element: AddClinicianResume },
  { path: '/clinician/profile/blscertificate', screenRight: "Clinician Profile", showSideBar: false, element: ClinicianBLSCertificate },
  { path: '/clinician/profile/addnewcertificate', screenRight: "Clinician Profile", showSideBar: false, element: ClinicianAddNewCertificate },
  { path: '/clinician/profile/uploadcertificate', screenRight: "Clinician Profile", showSideBar: false, element: ClinicianUploadCertificate },
  { path: '/clinician/profile/healthdocuments', screenRight: "Clinician Profile", showSideBar: false, element: ClinicianHealthDocument },
  { path: '/clinician/profile/uploaddocuments', screenRight: "Clinician Profile", showSideBar: false, element: ClinicianUploadDocument },
  { path: '/clinician/profile/issuedates', screenRight: "Clinician Profile", showSideBar: false, element: ClinicianIssueDate },
  { path: '/clinician/profile/expirationdates', screenRight: "Clinician Profile", showSideBar: false, element: ClinicianExpirationDate },
  { path: '/clinician/profile/notes', screenRight: "Clinician Profile", showSideBar: false, element: ClinicianNotes },
  { path: '/clinician/profile/onboardingDocument', screenRight: "Clinician Profile", showSideBar: false, element: ClinicianProfileOnboardingDocument },
  { path: '/clinician/profile/backgroundcheckemployeehandlebook', screenRight: "Clinician Profile", showSideBar: false, element: ClinicianBackgroundCheck },
  { path: '/clinician/profile/bankdetails/:mode/:accountID?', screenRight: "Clinician Profile", showSideBar: false, element: ClinicianBankDetails },
  { path: '/clinician/profile/assess-specialities/:specialityID', screenRight: "Clinician Profile", showSideBar: false, element: AssessSpecialities },
  { path: '/clinician/profile/add-experience', screenRight: "Clinician Profile", showSideBar: false, element: AddClinicianExperience },
  { path: '/clinician/profile/add-refernce', screenRight: "Clinician Profile", showSideBar: false, element: AddClinicianRefernce },
  { path: '/clinician/profile/add-certificate', screenRight: "Clinician Profile", showSideBar: false, element: AddClinicianCertificate },
  { path: '/clinician/profile/certificationdocuments', screenRight: "Clinician Profile", showSideBar: false, element: ClinicianCertificationDocument },
  { path: '/clinician/profile/certificationuploaddocuments', screenRight: "Clinician Profile", showSideBar: false, element: ClinicianCertificationUploadDocument },
  { path: '/clinician/profile/certificationissuedates', screenRight: "Clinician Profile", showSideBar: false, element: ClinicianCertificationIssueDate },
  { path: '/clinician/profile/certificationexpirationdates', screenRight: "Clinician Profile", showSideBar: false, element: ClinicianCertificationExpirationDate },
  { path: '/clinician/profile/certificationnotes', screenRight: "Clinician Profile", showSideBar: false, element: ClinicianCertificationNotes },
  { path: '/clinician/profile/assess-your-specialities', screenRight: "Clinician Profile", showSideBar: false, element: AssessYourSpecialities },
  { path: '/clinician/profile/assessment', screenRight: "Clinician Profile", showSideBar: false, element: Assessment },

  // clinician jobs
  { path: '/clinician/jobs', screenRight: "Clinician Jobs", showSideBar: true, title: "Jobs", icon: LuUser, element: ClinicianJobs },
  { path: '/clinician/jobs/:jobId/:clinicianId', screenRight: "Clinician Jobs", showSideBar: true, element: ClinicianAppliedJobDetails },
  { path: '/clinician/viewJob/:ID', screenRight: "Clinician Jobs", showSideBar: true, element: ViewJob },

  // My Jobs
  { path: "/clinician/myJobs", screenRight: "My Jobs", showSideBar: true, title: "My Jobs", icon: LuUser, element: MyJobs, },
  { path: '/clinician/offersaccepted', screenRight: "Clinician Jobs", showSideBar: false, element: JobofferAccepted },

  //Clinician Shift Schedule
  { path: '/clinician/schedule', screenRight: "Clinician Schedule", title: "Schedule", showSideBar: true, icon: EventAvailableIcon, element: ClinicianDashboardData },
  { path: '/clinician/schedule/unconfirmedshift', screenRight: "Clinician Schedule", showSideBar: false, element: ClinicianShiftScheduleList },
  { path: '/clinician/schedule/timeapproval', screenRight: "Clinician Schedule", showSideBar: false, element: ClinicianShiftScheduleList },
  { path: '/clinician/schedule/cancelshift', screenRight: "Clinician Schedule", showSideBar: false, element: ClinicianShiftScheduleList },
  { path: '/clinician/schedule/scheduleshift', screenRight: "Clinician Schedule", showSideBar: false, element: ClinicianShiftScheduleList },
  { path: '/clinician/schedule/requested', screenRight: "Clinician Schedule", showSideBar: false, element: ClinicianRequestShift },
  { path: '/clinician/schedule/open', screenRight: "Clinician Schedule", showSideBar: false, element: ClinicianOpenShift },
  { path: '/clinician/schedule/timeshift', screenRight: "Clinician Schedule", showSideBar: false, element: ClinicianTimeShift },
  { path: '/clinician/schedule/openshift', screenRight: "Clinician Schedule", showSideBar: false, element: ClinicianOpenShiftScheduleList },
  { path: '/clinician/schedule/allscheduleshift', screenRight: "Clinician Schedule", showSideBar: false, element: ClinicianAllShift },
  { path: '/clinician/cliniciantimeentries', screenRight: "Clinician Schedule", showSideBar: false, element: ClinicianTimeEntries },
  { path: '/clinician/cliniciantimeentry', screenRight: "Clinician Schedule", showSideBar: false, element: ClinicianTimeEntry },
  //Calender
  { path: '/clinician/Calendar', screenRight: "Clinician Schedule", showSideBar: false, element: Calendars },


  { path: '/clinician/messages', screenRight: "Clinician Messages", showSideBar: true, title: "Messages", icon: ForumRoundedIcon, element: ClinicianMessages },
  // Academy path is here
  { path: '/clinician/trainings', screenRight: "Clinician Learnings", title: "Learnings", icon: SchoolIcon, showSideBar: true, element: ClinicianTrainings },
  { path: '/clinician/trainings/:trainingID', screenRight: "Clinician Learnings", showSideBar: false, element: ClinicianLessonDetails },
  { path: '/clinician/viewcertificate/:trainingID', screenRight: "Clinician Learnings", showSideBar: true, element: ViewCertificate },
  { path: '/clinician/inprogress', screenRight: "Clinician Learnings", showSideBar: true, element: InProgress },
  { path: '/clinician/completedcertificate', screenRight: "Clinician Learnings", showSideBar: true, element: CompletedCertificate },
  { path: '/clinician/lessons', screenRight: "Clinician Learnings", showSideBar: true, element: Lessons },
  //Wallet
  { path: "/clinician/wallet", screenRight: "Clinician Wallet", title: "Wallet", icon: LuWallet, showSideBar: true, element: ClinicianWalletData, },
  //Invite Friend
  { path: "/clinician/invitefriend", screenRight: "Clinician Invite Friend", title: "Invite Friend", icon: LuUser, showSideBar: true, element: InviteFriendData, },
  //help
  { path: "/clinician/help", screenRight: "Clinician Help", title: "Help", icon: LuHelpCircle, showSideBar: true, element: ClinicianHelpData, },


  //ritik added above speciality path and the below one toomu





  //______________________________________________________________________________________________________________________________________________________________________________



  //Facility Path
  { path: '/facility/profile', screenRight: "Facility", title: "Facility", showSideBar: true, icon: LuUser, element: FacilityDashboard },
  { path: '/facility/profile/speciality', screenRight: "Facility", showSideBar: false, element: AddSpecialtyFacility },
  { path: '/facility/addLocation', screenRight: "Facility", showSideBar: false, icon: LuUser, element: AddLocation },
  { path: '/facility/Calendar', screenRight: "Schedule", showSideBar: false, element: Calendar },
  { path: '/facility/schedule/calendar', screenRight: "Schedule", showSideBar: false, element: ShiftCalendar },
  { path: '/facility/jobs', screenRight: "Jobs", title: "Jobs", showSideBar: true, icon: WorkOutlineIcon, element: FacilityJobs },
  { path: '/facility/jobs/postJob', screenRight: "Jobs", showSideBar: false, element: MultiStepJobPost },
  { path: '/facility/viewJob', screenRight: "Jobs", showSideBar: true, element: ViewJobInFacility },
  { path: '/facility/viewJob/:jobId/:clinicianId', screenRight: "Jobs", showSideBar: true, element: ViewJobInFacility },
  { path: '/facility/ClinicianTimesheet/:USER_ID/:COMMON_ID', screenRight: "Jobs", showSideBar: true, element: ViewClinicianTimeSheet },

  // Posted Job
  { path: '/facility/facilityPostedJob', screenRight: "Posted Jobs", title: "Posted Jobs", showSideBar: true, icon: WorkOutlineIcon, element: PostedJobs },
  { path: '/facility/view-jobDetails', screenRight: "Posted Jobs", showSideBar: true, element: ViewJobAndClinician },

  //facility Schedule Path
  { path: '/facility/schedule', screenRight: "Schedule", title: "Schedule", showSideBar: true, icon: EventAvailableIcon, element: FacilityDashboardData },
  { path: '/facility/schedule/unconfirmedshift', screenRight: "Schedule", showSideBar: false, element: FacilityRequesedShiftScheduleList },
  { path: '/facility/schedule/scheduleshift', screenRight: "Schedule", showSideBar: false, element: FacilityApprovedShiftScheduleList },
  { path: '/facility/schedule/timeapproval', screenRight: "Schedule", showSideBar: false, element: FacilityTimeApprovalShiftScheduleList },
  { path: '/facility/schedule/openshift', screenRight: "Schedule", showSideBar: false, element: FacilityOpenShiftScheduleList },
  { path: '/facility/schedule/cancelshift', screenRight: "Schedule", showSideBar: false, element: FacilityCanceledShiftScheduleList },

  // New shift category routes
  { path: '/facility/schedule/todayshifts', screenRight: "Schedule", showSideBar: false, element: FacilityTodayShiftsList },
  { path: '/facility/schedule/upcomingshifts', screenRight: "Schedule", showSideBar: false, element: FacilityUpcomingShiftsList },
  { path: '/facility/schedule/pastshifts', screenRight: "Schedule", showSideBar: false, element: FacilityPastShiftsList },
  { path: '/facility/schedule/completedshifts', screenRight: "Schedule", showSideBar: false, element: FacilityCompletedShiftsList },

  // Messages
  { path: '/facility/messages/inbox', screenRight: "Facility Messages", title: "Messages", showSideBar: true, icon: ForumRoundedIcon, element: Messages }, // some changes needs to be made

  // Roles
  { path: '/facility/roles', screenRight: "Facility Roles", title: "Role", showSideBar: true, icon: ManageAccountsOutlinedIcon, element: Roles },
  { path: '/facility/add-role/:ID?', screenRight: "Facility Roles", element: AddRole },

  // User
  { path: '/facility/user-management', screenRight: "Facility Manage User", title: "User Management", showSideBar: true, icon: ManageAccountsOutlinedIcon, element: AdminUsers },
  { path: '/facility/add-user', screenRight: "Facility Manage User", element: AddUser },
  { path: '/facility/add-user/:ID', screenRight: "Facility Manage User", element: AddUser },

  // Payment Transactions
  { path: '/facility/payment-transactions', screenRight: "Facility Payment Transactions", title: "Payment Transactions", showSideBar: true, icon: ReceiptLongIcon, element: FacilityTransactionReport },

  // Clinicians
  { path: '/facility/clinicians', screenRight: "Facility Clinician", title: "Clinicians", showSideBar: true, icon: ManageAccountsOutlinedIcon, element: FacilityClinicians },
  { path: "/facility/clinican-users/:ID/:JOBID/:STATUS", screenRight: "Facility Clinician", showSideBar: true, element: ViewClinicianProfile },
  { path: "/facility/clinican-users/:ID/", screenRight: "Facility Clinician", showSideBar: true, element: ViewClinicianProfile }, //new 07 April
  { path: "/facility/clinican-users/:ID/assess-specialities/:specialityID/", screenRight: "Facility Clinician", showSideBar: true, element: AssessSpecialitiesById }, //new 07 April
  { path: '/facility/clinician-users/view-cliniciandocuments', screenRight: "Facility Clinician", showSideBar: false, element: ClinicianHealthDocument },
  { path: "/facility/clinican-users/view-license/:licenseID", screenRight: "Facility Clinician", showSideBar: false, element: AddClinicianLicense },
  { path: "/facility/clinician-users/view-resume", screenRight: "Facility Clinician", showSideBar: false, element: AddClinicianResume },
  { path: "/facility/clinician-users/view-specialty/:specialityID", screenRight: "Facility Clinician", showSideBar: false, element: AssessSpecialities },
  // { path: "/facility/clinician-users/view-cliniciandocuments", screenRight: "Facility Clinician", showSideBar: false, element: ClinicianEmployeeHandleBook },
  { path: "/facility/clinician-profile/view-onboardingDocument", screenRight: "Facility Clinician", showSideBar: false, element: ClinicianProfileOnboardingDocument },
  // { path: '/facility/jobs', screenRight: "Facility Clinician", title: "Facility Profile", showSideBar: true, icon: WorkOutlineIcon, element: <Jobs /> }


  { path: '/facility/schedule/pendingshift', screenRight: "Schedule", showSideBar: false, element: FacilityPendingShiftRequestedList },
  { path: '/facility/schedule/requested', screenRight: "Schedule", showSideBar: false, element: FacilityRequestShift },
  { path: '/facility/facilityscheduleshifts', screenRight: "Schedule", showSideBar: false, element: FacilityScheduleShift },
  { path: '/facility/facilitytimeentries', screenRight: "Schedule", showSideBar: false, element: FacilityTimeEntries },
  { path: '/facility/facilitytimeentry', screenRight: "Schedule", showSideBar: false, element: FacilityTimeEntry },
  { path: '/facility/facilitydocument', screenRight: "Schedule", showSideBar: false, element: FacilityDocument },

  { path: '/facility/facilityPdf', screenRight: "Schedule", showSideBar: false, element: FacilityDocument },


  { path: '/facility/facilityapprove', screenRight: "Schedule", showSideBar: false, element: FacilityApprove },
  { path: '/facility/facilitytimeapproval', screenRight: "Schedule", showSideBar: false, element: FacilityTimeApproval },
  { path: '/facility/facilityopenshifts', screenRight: "Schedule", showsSideBar: false, element: FacilityOpenShifts },
  { path: '/facility/facilitycancelshifts', screenRight: "Schedule", showSideBar: false, element: FacilityCancelShifts },
  { path: '/facility/facilitytransactionlist', screenRight: "Schedule", showSideBar: false, element: TransactionList },

  //Timesheet 
  { path: '/facility/timesheet', screenRight: "TimesheetsAndPayments", title: "Timesheets & Payments", showSideBar: true, icon: MdPayments, element: AllTimeSheet },
  { path: '/facility/timesheet/view-clinicians/:ID', screenRight: "TimesheetsAndPayments", showSideBar: true, element: ApplicantsInTimeSheet },
  { path: "/facility/timesheet/clinician-details/:mappedJobId", screenRight: "TimesheetsAndPayments", showSideBar: true, element: ClinicianTimesheetForPayment },
  { path: "/facility/timesheet/payment/:transactionID?", screenRight: "TimesheetsAndPayments", showSideBar: false, element: PaymentConfirmationScreen },

  //Invite Friend
  { path: "/facility/invitefriend", screenRight: "Invite Friend", title: "Invite Friend", icon: LuUser, showSideBar: true, element: FacilityInviteFriend, },




  //______________________________________________________________________________________________________________________________________________________________________________
  //Dashboard
  { path: "/admin/dashboard", screenRight: "AdminDashboard", title: "Dashboard", icon: BsCardChecklist, showSideBar: true, element: AdminDashboard },

  // clinician
  { path: '/admin/clinician-users', screenRight: 'Clinicians', title: "Clinicians", showSideBar: true, icon: LiaUserNurseSolid, element: AdminClinicians },
  { path: '/admin/clinician-users/edit-license/:licenseID', screenRight: "Clinicians", showSideBar: false, element: AddClinicianLicense },
  { path: '/admin/clinician-users/view-license/:licenseID', screenRight: "Clinicians", showSideBar: false, element: AddClinicianLicense },
  { path: '/admin/clinician-users/edit-certificationdocuments', screenRight: "Clinicians", showSideBar: false, element: ClinicianCertificationDocument },
  { path: '/admin/clinician-users/view-certificationdocuments', screenRight: "Clinicians", showSideBar: false, element: ClinicianCertificationDocument },
  { path: '/admin/clinician-users/upload-certificationdocuments', screenRight: "Clinicians", showSideBar: false, element: ClinicianCertificationUploadDocument },
  { path: '/admin/clinician-users/issue-certificationdocuments', screenRight: "Clinicians", showSideBar: false, element: ClinicianCertificationIssueDate },
  { path: '/admin/clinician-users/expiration-certificationdocuments', screenRight: "Clinicians", showSideBar: false, element: ClinicianCertificationExpirationDate },
  { path: '/admin/clinician-users/notes-certificationdocuments', screenRight: "Clinicians", showSideBar: false, element: ClinicianCertificationNotes },
  { path: '/admin/clinician-users/edit-cliniciandocuments', screenRight: "Clinicians", showSideBar: false, element: ClinicianHealthDocument },
  { path: '/admin/clinician-users/view-cliniciandocuments', screenRight: "Clinicians", showSideBar: false, element: ClinicianHealthDocument },

  { path: '/admin/clinician-users/upload-cliniciandocuments', screenRight: "Clinicians", showSideBar: false, element: ClinicianUploadDocument },//05 May
  { path: '/admin/clinician-users/issuedates-cliniciandocuments', screenRight: "Clinicians", showSideBar: false, element: ClinicianIssueDate },//05 May
  { path: '/admin/clinician-users/expirationdates-cliniciandocuments', screenRight: "Clinicians", showSideBar: false, element: ClinicianExpirationDate },//05 May
  { path: '/admin/clinician-users/notes-cliniciandocuments', screenRight: "Clinicians", showSideBar: false, element: ClinicianNotes },//05 May

  { path: "/admin/clinician-users/:view", screenRight: "Clinicians", showSideBar: true, element: ClinicianUserProfile },
  { path: "/admin/clinician-users/:edit", screenRight: "Clinicians", showSideBar: true, element: ClinicianUserProfile },
  { path: "/admin/clinician-users/view", screenRight: "Clinicians", showSideBar: true, element: ClinicianUserProfile },
  { path: "/admin/clinician-users/edit", screenRight: "Clinicians", showSideBar: true, element: ClinicianUserProfile },

  { path: '/admin/clinician-users/edit-about', screenRight: "Clinicians", showSideBar: false, element: ManageEditClinicianAbout },
  { path: '/admin/clinician-users/edit-about/changeAddress', screenRight: "Clinicians", showSideBar: false, element: ClinicianAddressEditProfile },
  // { path: '/admin/clinician-users/view-specialty', screenRight: "Clinicians", showSideBar: false, element: AddClinicianSpecialty },
  //Karan  

  //Added By Rawat
  { path: '/admin/clinician-users/add-license', screenRight: "Clinicians", showSideBar: false, element: AddClinicianLicense },
  { path: '/admin/clinician-users/add-experience', screenRight: "Clinicians", showSideBar: false, element: AddClinicianExperience },
  { path: '/admin/clinician-users/edit-reference', screenRight: "Clinicians", showSideBar: false, element: AddClinicianRefernce },
  { path: '/admin/clinician-users/edit-specialty', screenRight: "Clinicians", showSideBar: false, element: AddClinicianSpecialty },
  { path: '/admin/clinician-users/add-certificate', screenRight: "Clinicians", showSideBar: false, element: ClinicianAddNewCertificate },
  //New Addition by karan
  { path: '/admin/clinician-users/view-trainings', screenRight: "Clinicians", icon: SchoolIcon, showSideBar: false, element: ClinicianTrainings },
  { path: '/admin/clinician-users/view-trainings/:trainingID', screenRight: "Clinicians", showSideBar: false, element: ClinicianLessonDetails },

  { path: '/admin/requestedlist-users', screenRight: 'Requested List', title: "Requested List", showSideBar: true, icon: LiaUserNurseSolid, element: AdminRequestedList },
  { path: "/admin/requestedlist-users/view-clinician", screenRight: "Clinicians", showSideBar: true, element: ClinicianUserProfile },

  { path: "/admin/requestedlist-users/view-facility", screenRight: "Facilities", showSideBar: true, element: FacilityUserProfile },


  { path: '/admin/profile/view-CheckList/:specialityID', screenRight: "Clinicians", showSideBar: false, element: ClinicianCheck }, //New 03april
  { path: '/admin/profile/edit-CheckList/:specialityID', screenRight: "Clinicians", showSideBar: false, element: ClinicianCheck }, //New 03april
  { path: '/admin/profile/assess-specialities/:specialityID', screenRight: "Clinicians", showSideBar: false, element: AssessSpecialities },
  { path: '/admin/clinician-users/edit-specialty', screenRight: "Clinicians", showSideBar: false, element: AddClinicianSpecialty },
  { path: '/admin/clinician-users/edit-resume', screenRight: "Clinicians", showSideBar: false, element: AddClinicianResume },
  { path: '/admin/clinician-users/view-resume', screenRight: "Clinicians", showSideBar: false, element: AddClinicianResume },
  { path: '/admin/connectUser/:ID', screenRight: "Facilities", showSideBar: false, element: ConfirmConnection },
  { path: '/admin/clinician-profile/edit-onboardingDocument', screenRight: "Clinicians", showSideBar: false, element: ClinicianProfileOnboardingDocument },
  { path: '/admin/clinician-profile/view-onboardingDocument', screenRight: "Clinicians", showSideBar: false, element: ClinicianProfileOnboardingDocument },
  { path: '/admin/profile/edit-assess-your-specialities', screenRight: "Clinicians", showSideBar: false, element: AssessYourSpecialities },
  { path: '/admin/profile/edit-assessment', screenRight: "Clinicians", showSideBar: false, element: Assessment },
  { path: '/admin/mutlipart/:ID?', screenRight: "User Management", showSideBar: false, element: GenericMultiStep },
  { path: '/admin/profile/view-CheckList/:specialityID', screenRight: "Clinicians", showSideBar: false, element: ClinicianCheck }, //New 03april
  { path: '/admin/profile/edit-CheckList/:specialityID', screenRight: "Clinicians", showSideBar: false, element: ClinicianCheck }, //New 03april
  { path: '/admin/profile/assess-specialities/:specialityID', screenRight: "Clinicians", showSideBar: false, element: AssessSpecialities },
  { path: '/admin/importUsers', screenRight: 'Clinicians', element: ImportUsers },

  //Facility
  { path: '/admin/facility-users', screenRight: "Facilities", title: "Facility", showSideBar: true, icon: BiClinic, element: AdminFacilities },
  { path: "/admin/facility-users/shiftRate/:ID", screenRight: "Facilities", showSideBar: false, element: ShiftRates },
  { path: "/admin/facility-users/view", screenRight: "Facilities", showSideBar: true, element: FacilityUserProfile },
  { path: "/admin/facility-users/edit", screenRight: "Facilities", showSideBar: true, element: FacilityUserProfile },
  { path: '/admin/facilty-users/edit-about', screenRight: "Facilities", showSideBar: false, element: ManageEditFacilityAbout },
  // Role
  { path: '/admin/roles', screenRight: "Roles", title: "Role", showSideBar: true, icon: ManageAccountsOutlinedIcon, element: Roles },
  { path: '/admin/add-role/:ID?', screenRight: "Roles", element: AddRole },
  // user-management
  { path: '/admin/user-management', screenRight: "User Management", title: "User Management", showSideBar: true, icon: ManageAccountsOutlinedIcon, element: AdminUsers },
  { path: "/admin/add-user/:ID?", screenRight: "User Management", element: AddUser },
  { path: "/admin/user-access", screenRight: "User Management", element: UserAccess },

  // Profile Criteria
  { path: '/admin/profile-criteria', screenRight: "Profile Criteria", title: "Profile Criteria", showSideBar: true, icon: BsCardChecklist, element: AdminProfileCriteria },
  { path: '/admin/profile-criteria/work-area', screenRight: "Profile Criteria", showSideBar: true, element: WorkArea },
  { path: "/admin/add-workArea/:ID?", screenRight: "Profile Criteria", element: AddWorkArea },
  { path: '/admin/profile-criteria/work-type', screenRight: "Profile Criteria", showSideBar: true, element: WorkType },
  { path: "/admin/add-workType/:ID?", screenRight: "Profile Criteria", element: AddWorkType },
  { path: '/admin/profile-criteria/fetchSpecialtyRoleMappings', screenRight: "Profile Criteria", showSideBar: true, element: Specialties },
  { path: "/admin/profile-criteria/add-specialty/:ID?", screenRight: "Profile Criteria", element: AddSpecialty },
  { path: "/admin/profile-criteria/map-specialtyToRole/:ID?", screenRight: "Profile Criteria", element: AssignSpecialty },
  { path: "/admin/profile-criteria/add-jobRole/:ID?", screenRight: "Profile Criteria", element: AddJobRole },
  { path: "/admin/profile-criteria/jobRoleCredentials/:ID?", screenRight: "Profile Criteria", element: JobRoleCredentials },
  { path: "/admin/profile-criteria/map-roleToSpecialty/:ID?", screenRight: "Profile Criteria", element: AssignJobRole },
  { path: "/admin/profile-criteria/OnBoardingDocuments", screenRight: "Profile Criteria", showSideBar: true, element: AddOnBoardingDocuments },
  { path: "/admin/profile-criteria/HealthDocuments", screenRight: "Profile Criteria", showSideBar: true, element: HealthDocuments },
  { path: "/admin/profile-criteria/LearningDocuments", screenRight: "Profile Criteria", showSideBar: true, element: LearningDocuments },
  { path: "/admin/profile-criteria/Certifications", screenRight: "Profile Criteria", showSideBar: true, element: Certifications },
  { path: "/admin/profile-criteria/FAQs", screenRight: "Profile Criteria", showSideBar: true, element: FAQs },
  { path: "/admin/add-FAQ/:ID?", screenRight: "Profile Criteria", element: AddFAQs },
  { path: "/admin/edit-FAQ/:ID?", screenRight: "Profile Criteria", element: AddFAQs },
  { path: "/admin/FAQ/add/:ID", screenRight: "Profile Criteria", element: AddFAQs },

  // Admin Accounting
  { path: '/admin/admin-accounting', screenRight: "Profile Accounting", title: "Accounting", showSideBar: true, icon: VscAccount, element: AdminAccounting },
  //Schedule
  { path: "/admin/schedule", screenRight: "AdminSchedule", title: "Schedule", icon: BsCardChecklist, showSideBar: true, element: AdminSchedule },
  //Jobs
  { path: "/admin/jobs", screenRight: "AdminJob", title: "Jobs", icon: WorkOutlineIcon, showSideBar: true, element: AdminJobs },

  //Requested Job
  { path: '/admin/requested-job', screenRight: "Requested Job", title: "Requested Jobs", showSideBar: true, icon: WorkOutlineIcon, element: RequestedJobs },
  { path: '/admin/requested-job/view/:ID', screenRight: "Requested Job", showSideBar: true, element: ViewJobApplicantsDetails },
  //Timesheet&Payments
  { path: "/admin/timesheet", screenRight: "Timesheet", title: "Timesheet & Payments", showSideBar: true, icon: MdPayments, element: AllTimeSheet },
  { path: '/admin/timesheet/view-clinicians/:ID', screenRight: "Timesheet", showSideBar: true, element: ApplicantsInTimeSheet },
  { path: "/admin/timesheet/clinician-details/:mappedJobId", screenRight: "Timesheet", showSideBar: true, element: ClinicianTimesheetForPayment },


  // { path: '/admin/messages', screenRight: "Admin Messages", showSideBar: true, title: "Messages", icon: ForumRoundedIcon, element: AdminMessages },
  { path: '/admin/payment-transactions', screenRight: "Payment Transactions", title: "Payment Transactions", showSideBar: true, icon: ManageAccountsOutlinedIcon, element: AdminTransactionReport },







]

const processPath = (path) => {
  return path.split("/").splice(2, path.length).join("/");
};

const fetchRoute = (userRole) => {
  let clinicianUserRoutes = []
  let facilityUserRoutes = []
  let adminRoutes = []
  let commonRoutes = []
  let menu = [];
  const rights = userRole?.userDetails?.ROLE_RIGHT || [];
  const annotatedRoutes = allRoutes.map((route) => {
    const matchingRight = rights.find((val) => val.SCREEN_NAME === route.screenRight);
    return {
      ...route,
      SCREEN_RIGHT: matchingRight?.SCREEN_RIGHT || "None",
    };
  });

  // Build menu strictly from rights (visible items only)
  menu = annotatedRoutes.filter((route) =>
    rights.some((val) => val.SCREEN_NAME === route.screenRight && val.SCREEN_RIGHT !== "None")
  );

  // Always register role routes by path prefix, independent of rights
  if (userRole?.userDetails?.USER_TYPE === "facility") {
    facilityUserRoutes = annotatedRoutes.filter((r) => r.path.startsWith('/facility/'));
  } else if (userRole?.userDetails?.USER_TYPE === "admin") {
    adminRoutes = annotatedRoutes.filter((r) => r.path.startsWith('/admin/')
    );
  } else if (userRole?.userDetails?.USER_TYPE === "clinician") {
    clinicianUserRoutes = annotatedRoutes.filter((r) => r.path.startsWith('/clinician/'));
  } else {
    commonRoutes = annotatedRoutes.filter((r) => !r.path.startsWith('/admin/') && !r.path.startsWith('/clinician/') && !r.path.startsWith('/facility/'));
  }


  let data = {
    menu: menu, role: [
      { path: LOGIN_PATH, element: <Login /> },
      { path: HOME_PATH, element: <Home /> },
      { path: '/viewJob/:ID', screenRight: "Profile", element: <ViewJob /> },
      { path: '/viewJob/:ID', screenRight: "Profile", element: <ViewJob /> },
      { path: '/forgotpassword', element: <MultiStepForgetPassword /> },
      { path: '/otpverification', element: <MultiStepForgetPassword /> },
      { path: '/changepassword', element: <MultiStepForgetPassword /> },
      { path: '/signup', element: <ChooseSignupType /> },
      { path: '/signupAsClinician', element: <ClinicianSignupForm /> },
      { path: '/clinicianOnboardSetup/:USER_ID', element: <ClinicianOnBoardSetup /> },
      { path: "/unauthorized", element: <Unauthorized /> },
      { path: '/signupAsFacility', element: <FacilitySignupForm /> },
      { path: '/facilityEditProfile', element: <FacilityEditProfile /> },
      { path: '/confirm-connection/:ID', element: <ConfirmConnection /> },
      { path: '/mobile/pdf-viewer', element: <MobilePdfViewer /> },
      { path: '/mobile/clinician/pdf-edit', element: <MobileClinicianEditOnboardingDocument /> },
      { path: '/job-offer/:userId/:jobId', element: <JobOfferEmailView /> },
      {
        path: "/",
        element: <LayoutWrapper />,
        children: [
          { path: '/', element: <RootRoute /> },
          {
            path: 'admin/*',
            element: (
              <Routes>
                {adminRoutes.map((route, index) => {
                  return (
                    <Route
                      key={`adminlayout-${index}`}
                      element={<FullLayout showSideBar={route.showSideBar} />}
                    >
                      <Route
                        key={`adminroute-${index}`}
                        path={processPath(route.path)}
                        element={
                          <ProtectedRoute
                            allowedRoles={['admin']}
                            access={route?.SCREEN_RIGHT}
                          >
                            <route.element access={route?.SCREEN_RIGHT} />
                          </ProtectedRoute>
                        }
                      />
                    </Route>
                  );
                })}
                <Route path="*" element={<Navigate to="/unauthorized" replace />} />
              </Routes>
            ),
          },
          {
            path: 'clinician/*',
            element: (
              <Routes>
                {clinicianUserRoutes.map((route, index) => (
                  <Route key={`clinicianlayout-${index}`} element={<FullLayout showSideBar={route.showSideBar} />}>
                    <Route
                      key={`clinicianroute-${index}`}
                      path={processPath(route.path)}
                      element={
                        <ProtectedRoute allowedRoles={['clinician']} access={route?.SCREEN_RIGHT}>
                          <route.element access={route?.SCREEN_RIGHT} />
                        </ProtectedRoute>
                      }
                    />
                  </Route>
                ))}
                <Route path="*" element={<Navigate to="/unauthorized" replace />} />
              </Routes>

            ),
          },
          {
            path: 'facility/*',
            element: (
              <Routes>
                {facilityUserRoutes.map((route, index) => (
                  <Route key={`facilitylayout-${index}`} element={<FullLayout showSideBar={route.showSideBar} />}>
                    <Route
                      key={`facilityroute-${index}`}
                      path={processPath(route.path)}
                      element={
                        <ProtectedRoute allowedRoles={['facility']} access={route?.SCREEN_RIGHT}>
                          <route.element access={route?.SCREEN_RIGHT} />
                        </ProtectedRoute>
                      }
                    />
                  </Route>
                ))}
                <Route path="*" element={<Navigate to="/unauthorized" replace />} />
              </Routes>
            ),
          },
          {
            path: '/*',
            element: (
              <Routes>
                {commonRoutes.map((route, index) => (
                  <Route key={`commonlayout-${index}`} element={<FullLayout showSideBar={route.showSideBar} />}>
                    <Route
                      key={`commonroute-${index}`}
                      path={processPath(route.path)}
                      element={
                        <ProtectedRoute allowedRoles={['admin', 'clinician', 'facility']} access={route?.SCREEN_RIGHT}>
                          <route.element access={route?.SCREEN_RIGHT} />
                        </ProtectedRoute>
                      }
                    />
                  </Route>
                ))}
                <Route path="*" element={<Navigate to="/unauthorized" replace />} />
              </Routes>

            ),
          },
        ],

      },
      { path: "*", element: <NotFoundPage /> },
    ]
  }
  return data;
}

// Export function to get screen usage mapping (only main sidebar items)
export const getScreenUsageMap = () => {
  const map = {};

  allRoutes.forEach((route) => {
    // Only include routes that are sidebar menu items (have title and showSideBar: true)
    if (route.screenRight && route.title && route.showSideBar === true) {
      if (!map[route.screenRight]) {
        map[route.screenRight] = [];
      }
      // Avoid duplicates
      if (!map[route.screenRight].some(item => item.title === route.title)) {
        map[route.screenRight].push({ title: route.title, path: route.path });
      }
    }
  });

  return map;
};

export default fetchRoute;

